import { prepareDataForDropdown } from '../../../../../components/organisms/Filters/utils';
import useFetchData from '../../../../../hooks/fetchHook';
import { DC } from '../controllers/variables';

export const useGetFilters = ({ ignore }) => {
  const [{ data, isLoading = true, isError, error }, _, refetchFilters] =
    useFetchData('office_reviews/filters', {
      formatter,
      ignore,
    });

  return {
    data,
    isLoading,
    isError,
    error,
    refetchFilters,
  };
};

export const formatter = data => {
  const { statuses, risk_types } = data;

  const newOps = {};

  newOps[DC.REVIEW_STATUS] = prepareDataForDropdown(
    statuses,
    'prReview',
    'prReview'
  );

  newOps[DC.RISK_TYPE] = prepareDataForDropdown(
    risk_types,
    'paRiskType',
    'paRiskType'
  );

  return newOps;
};
